import { render } from "./ViewEquipMarchand.vue?vue&type=template&id=5eb60f20&scoped=true&ts=true"
import script from "./ViewEquipMarchand.vue?vue&type=script&lang=ts"
export * from "./ViewEquipMarchand.vue?vue&type=script&lang=ts"

import "./ViewEquipMarchand.vue?vue&type=style&index=0&id=5eb60f20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb60f20"]])

export default __exports__